import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { amber, lightGreen, indigo, blue, purple, red, cyan } from '@mui/material/colors';
import { Avatar, Box, CardHeader, Fab, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { AddRounded, ArrowForwardRounded, ChairRounded, DesktopMacRounded, HandymanRounded } from '@mui/icons-material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import Dialog from '../../common/Dialog';
import TitleWithEndAction from '../../common/TitleWithEndAction';
// import Demands from './Forms/Demands';
// import DemandSingle from './Single/DemandSingle';
import Articles from './Forms/Articles';
import ArticleList from './List/ArticleList';
import Sessions from './Forms/Sessions';
import SessionList from './List/SessionList';
import SessionSingle from './Single/SessionSingle';

class CardActionDemand extends Component {
    state = {  }
    render() {
        return (
            <Box p={1}>
                <Paper
                    elevation={0}
                    style={{ cursor: "pointer"}}
                    onClick={this.props.action}
                    className="equipement_button_card"
                >
                    <CardHeader
                        avatar={
                            <Avatar sx={{ bgcolor: this.props.color }}>
                                {this.props.icon}
                            </Avatar>
                        }
                        action={
                            <IconButton aria-label="settings">
                                <ArrowForwardRounded />
                            </IconButton>
                        }
                        title={<Typography variant="button">{this.props.title}</Typography>}
                        // subheader="September 14, 2016"
                    />
                </Paper>
            </Box>
        );
    }
}

class DemandGeneral extends Component {
    state = { 
        openForm: false,
        openActions: false,
        type: "",
        selected: {},
        openSingle: false, 
        SESSION: {}, 
        field: "",
        index: 0
    }
    componentDidMount = () => {
        window.scrollTo(0, 0);
        // if(isEmpty(this.props.EMPLOYEES) ){
        //     this.props.fetchEmployees()
        // }
        if(isEmpty(this.props.ARTICLES) ){
            this.props.fetchArticles()
        }
        if(isEmpty(this.props.SESSIONS) ){
            this.props.fetchSessions()
        }
        // if(isEmpty(this.props.DEMANDS) ){
        //     this.props.fetchAllDemands()
        // }
        
    }
    render() {
        const { openForm, openActions, openSingle, SESSION, SESSIONS, index } = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Box>
                <TitleWithEndAction
                    title="Demandes de Matériel"
                    // action={() => this.props.openFormDownload("/extract/equipements")}
                    // actionTitle="Télécharger" 
                    // disabled={this.props.downloading}
                >
                    <Fab 
                        color={"secondary"} 
                        onClick={() => this.setState({ openActions: true })} 
                        title="Nouveau"
                        size="small"
                    >
                        <AddRounded />
                    </Fab>
                </TitleWithEndAction>
                {openForm && this.state.type === "article" &&
                    <Articles
                        handleClose={()=> this.setState({ openForm: false })}
                        type={this.state.type}
                        {...this.props}
                    />
                }
                {openForm && this.state.type === "session" &&
                    <Sessions
                        handleClose={()=> this.setState({ openForm: false })}
                        type={this.state.type}
                        {...this.props}
                    />
                }
                
                {openActions &&
                    <Dialog
                        maxWidth="xs"
                        title="Créer"
                        close={()=> this.setState({ openActions: false })}
                    >
                        <CardActionDemand
                            title="Session"
                            action={()=> this.setState({ openForm: true, type: "session" })}
                            color={cyan[300]}
                            icon={<ChairRounded />}
                        />
                        <CardActionDemand
                            title="Article"
                            action={()=> this.setState({ openForm: true, type: "article" })}
                            color={amber[300]}
                            icon={<DesktopMacRounded />}
                        />                  
                    </Dialog>
                }
                {openSingle && SESSION &&
                    <SessionSingle
                        {...this.props}
                        {...this.state}
                        close={() => this.setState({ openSingle: false, SESSION: {}, field: ""})}
                    />
                }
                <SwipeableTabs
                    returnIndex={(index) => this.setState({ index })}
                    labels={["Sessions", "Articles", "Demandes"]}
                >
                    {index == 0 ?
                        <SessionList 
                            handleSingle={
                                (item) => this.setState({ openSingle: true, SESSION: item})
                            } 
                            {...this.props} 
                        />
                         :
                        <Box></Box>
                    }
                    {index == 1 ?
                        <ArticleList 
                            handleSingle={
                                (item) => this.setState({ openSingle: true, ARTICLE: item})
                            } 
                            {...this.props} 
                        />
                         :
                        <Box></Box>
                    }
                    {index == 2 ?
                        <ArticleList 
                            handleSingle={
                                (item) => this.setState({ openSingle: true, DEMAND: item})
                            } 
                            {...this.props} 
                        />
                        :
                        <Box></Box>
                    }
                </SwipeableTabs>
            </Box>
        );
    }
}

export default DemandGeneral;